<template>
  <div id="contact" class="sec">
    <div class="MyContainer-fluid">
      <div class="title-center">
        <h1>Contáctenos</h1>
      </div>
    </div>
    <div class="MyContainer contact">
      <div class="formBox">
        <form>
          <div class="form-group">
            <label for="nameInput"
              >Nombre <span style="color: red;">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="nameInput"
              placeholder="Nombre"
            />
          </div>
          <div class="form-group">
            <label for="empresInput">Empresa (opcional)</label>
            <input
              type="text"
              class="form-control"
              id="empresInput"
              placeholder="Empresa"
            />
          </div>
          <div class="form-group">
            <label for="emailInput"
              >Correo electrónico <span style="color: red;">*</span></label
            >
            <input
              type="email"
              class="form-control"
              id="emailInput"
              placeholder="Correo"
            />
          </div>
          <div class="form-group">
            <label for="asuntoInput"
              >Asunto <span style="color: red;">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="asuntoInput"
              placeholder="Asunto"
            />
          </div>
          <div class="form-group">
            <label for="mensajeInput"
              >Mensaje <span style="color: red;">*</span></label
            >
            <textarea
              class="form-control"
              id="mensajeInput"
              rows="3"
            ></textarea>
          </div>
          <button type="button" class="btn btn-primary btn-lg btn-block">
            Enviar
          </button>
        </form>
      </div>
      <div class="infoBox">
        <h3>Información de contacto</h3>
        <ul>
          <li><b-icon icon="geo-alt"></b-icon>Chía, Cundinamarca Colombia</li>
          <li><b-icon icon="telephone-fill"></b-icon>(+57) 3208932127</li>
          <li><b-icon icon="at"></b-icon>info@overlabingenieria.com.co</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.sec {
  width: 100%;
  min-height: 80vh;
}

.MyContainer-fluid {
  height: auto;
  width: 100%;
}

.MyContainer {
  height: auto;
  width: 90%;
  margin: 0 5%;
}

.MyContainer-fluid .title-center {
  background: var(--secondary);
  text-align: center;
  padding: 10px;
}

.MyContainer .title-center h1 {
  color: #fff;
}
.contact {
  padding: 25px 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
}
.contact .formBox {
  min-width: 360px;
}
.contact .infoBox {
  min-width: 360px;
}
.contact .infoBox h3 {
  text-align: center;
  color: var(--primary);
}
.contact .infoBox ul {
  list-style: none;
}
</style>
